var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkCardExplore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6221_8914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5511 40.6048L14.8845 38.9382L21.4871 32.3557H5.20898V29.9919H21.4871L14.8845 23.4094L16.5511 21.7428L25.9821 31.1738L16.5511 40.6048ZM33.4501 28.2371L24.0191 18.8061L33.4501 9.375L35.1167 11.0216L28.5141 17.6242H44.7922V19.9879H28.5141L35.1167 26.5705L33.4501 28.2371Z",
    fill: "#00148C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6221_8914)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -2,
    width: 50,
    height: 50,
    fill: "#009DDC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCardExplore);
export default __webpack_public_path__ + "static/media/linkCard_explore.2537fa32854c47b6b2eaa73aa73badbd.svg";
export { ForwardRef as ReactComponent };